import { Directive, TemplateRef } from '@angular/core';
var NglLookupItemTemplate = (function () {
    function NglLookupItemTemplate(templateRef) {
        this.templateRef = templateRef;
    }
    NglLookupItemTemplate.decorators = [
        { type: Directive, args: [{ selector: '[nglLookupItem]' },] },
    ];
    /** @nocollapse */
    NglLookupItemTemplate.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NglLookupItemTemplate;
}());
export { NglLookupItemTemplate };
var NglLookupLabelTemplate = (function () {
    function NglLookupLabelTemplate(templateRef) {
        this.templateRef = templateRef;
    }
    NglLookupLabelTemplate.decorators = [
        { type: Directive, args: [{ selector: '[nglLookupLabel]' },] },
    ];
    /** @nocollapse */
    NglLookupLabelTemplate.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NglLookupLabelTemplate;
}());
export { NglLookupLabelTemplate };
var NglLookupHeader = (function () {
    function NglLookupHeader() {
    }
    NglLookupHeader.decorators = [
        { type: Directive, args: [{
                    selector: '[nglLookupHeader]',
                    host: {
                        '[class.slds-lookup__item--label]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglLookupHeader.ctorParameters = function () { return []; };
    return NglLookupHeader;
}());
export { NglLookupHeader };
//# sourceMappingURL=item.js.map